/**
 * El enlace de WhatsApp al despacho, con el mensaje ya escrito.
 *
 * El número vive en `VITE_WHATSAPP_NUMBER` y no se adivina: si está vacío, esto
 * devuelve null y quien lo use no pinta el botón. Vale más no ofrecer el canal
 * que mandar al usuario a un número equivocado.
 *
 * En el mensaje no va RFC ni ningún dato fiscal: es una conversación que se abre
 * en el teléfono del usuario y puede acabar en cualquier lado.
 */
const digitsOnly = (value) => String(value ?? "").replace(/\D/g, "");

export const whatsappLink = (message) => {
  const number = digitsOnly(import.meta.env.VITE_WHATSAPP_NUMBER);

  if (number.length < 10) {
    return null;
  }

  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};
